import { createAction } from 'redux-actions';

export const FETCH_USER_ACTIVITY = 'userActivity/fetch';
export const FETCH_USER_ACTIVITY_SUCCESSFUL = 'userActivity/fetchSuccessful';
export const FETCH_USER_ACTIVITY_FAILED = 'userActivity/fetchFailed';

export const auditActionCreators = {
  fetchUserActivity: createAction(FETCH_USER_ACTIVITY),
};
